import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const reload = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data || false);
    } catch (e) {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    setUser(r.data);
    return r.data;
  };
  const register = async (payload) => {
    const r = await api.post("/auth/register", payload);
    setUser(r.data);
    return r.data;
  };
  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, login, register, logout, reload }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
export const isStaff = (u) => !!u && u.approved && (u.role === "admin" || u.role === "coach");
